/**
 * @function serializeQuery
 * @param obj - object of params for search query
 * @return {string} - return search string for URL
 * @description
 * Function for decoding object of params to query search string
 */

const serializeQuery = (obj) => {
  const query = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (value !== undefined) {
        const param = Array.isArray(value) ? value.join(';') : value;
        if (param !== undefined) {
          query.push(encodeURIComponent(key) + '=' + encodeURIComponent(param));
        }
      }
    }
  }
  return query.join('&');
};

export default serializeQuery;
